import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grow from '@material-ui/core/Grow';
import Fade from '@material-ui/core/Fade';
import classNames from 'classnames';

import * as actions from '../actions';

const styles = (theme) => ({
	root: {
		paddingTop: theme.spacing.unit * 12,
		paddingBottom: theme.spacing.unit * 12,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		overflow: 'hidden'
	},
	text: {
		marginBottom: theme.spacing.unit * 5,
		textAlign: 'center'
	},
	button: {
		fontSize: 18,
		paddingLeft: theme.spacing.unit * 3,
		paddingRight: theme.spacing.unit * 3,
		paddingTop: theme.spacing.unit * 1.5,
		paddingBottom: theme.spacing.unit * 1.5,
	},
});

class Results extends Component {
	componentDidMount(nextProps) {
		const { exContainer, testMode } = this.props;

		if (testMode) {
			window.nl_loader.getTestAdmin().showButtons(exContainer);
		}
	}

	componentWillUnmount() {
		const { exContainer, testMode } = this.props;

		if (testMode) {
			window.nl_loader.getTestAdmin().hideButtons(exContainer);
		}
	}

	render() {
		const { classes, text, textSecondary, restartExercise, resultsVisible, showStartAgain } = this.props;

		return (
			<div className={classNames(classes.root)}>
				<Grow timeout={1000} in={resultsVisible}>
					<div>
						<Typography variant="display1" gutterBottom className={classes.text} color="textSecondary" dangerouslySetInnerHTML={{ __html: text }} />
						{
							textSecondary && (
								<Typography
									variant="headline"
									gutterBottom
									className={classes.text}
									color="textSecondary"
									dangerouslySetInnerHTML={{ __html: textSecondary }}
								/>
							)
						}
					</div>
				</Grow>
				<Fade in={resultsVisible} style={{ transitionDelay: 700, visibility: showStartAgain ? 'block' : 'hidden' }}>
					<Button variant="raised" color="primary" className={classNames('theme-background', 'theme-hover', classes.button)} onClick={restartExercise}>
						Start again
					</Button>
				</Fade>
			</div >
		);
	}
}

Results.propTypes = {
	classes: PropTypes.object.isRequired,
	text: PropTypes.string.isRequired,
	textSecondary: PropTypes.string,
	totalCorrectAnswers: PropTypes.number.isRequired, // eslint-disable-line
	itemsLength: PropTypes.number.isRequired, // eslint-disable-line
	restartExercise: PropTypes.func.isRequired,
	resultsVisible: PropTypes.bool.isRequired,
	testMode: PropTypes.string,
	exContainer: PropTypes.object,
	showStartAgain: PropTypes.bool,
};

Results.defaultProps = {
	testMode: undefined,
	exContainer: undefined,
	showStartAgain: false,
	textSecondary: undefined
};

function mapStateToProps({ exercise, loader }, ownProps) {
	return {
		totalCorrectAnswers: exercise.correctAnswers.filter(e => e).length,
		itemsLength: exercise.items.length,
		resultsVisible: exercise.resultsVisible,
		exContainer: loader.exContainer,
		testMode: loader.testMode,
		testSent: loader.testSent
	};
}

export default compose(
	withStyles(styles),
	connect(mapStateToProps, actions),
	withProps(ownProps => {
		if (ownProps.testMode) {
			if (ownProps.testSent) {
				return {
					text: 'You\'ve finished the test.',
					textSecondary: `You score was ${ownProps.totalCorrectAnswers} out of ${ownProps.itemsLength}.`
				};
			}
			return {
				text: 'You\'ve finished the test',
				textSecondary: 'Please, submit your results when you\'re ready.'
			};
		}
		return {
			text: `You got ${ownProps.totalCorrectAnswers} out of ${ownProps.itemsLength} correct answers.`,
			showStartAgain: true
		};
	})
)(Results);
